import { useAppContext } from '../../../hooks/useAppContext';
import useLocation from '../../../hooks/useLocation';
import { prependAppPath } from '../../../services/Url';
import { useEapState } from '../../Admin/EarlyAccessProgram/useEapState';
import { NewNavigation } from './presenter';

export default function PageNavigation() {
    const appContext = useAppContext();
    const { pathname } = useLocation();
    const [hasNewFeatures] = useEapState();

    return (
        <NewNavigation
            currentLocation={prependAppPath(pathname)}
            appContext={appContext}
            highlightComingSoon={hasNewFeatures}
        />
    );
}
